export default __webpack_public_path__ + "static/media/img/broowing-coffee.webp";